import { useCallback } from "react";
import { useRideStatuses as useRideStatusesBase } from "common-fe";
import { useScoreApi, unwrap } from "../api/scoreApi";

// announcer-fe wrapper around common-fe's useRideStatuses (#545/#642): wires
// score-api's batch endpoint (POST /rides/status, #544) as the fetcher, so the
// Order of Go reads the SINGLE server-derived status — no client-side
// derivation (#546).
//
// The base hook already pauses the interval when the tab is hidden and does an
// immediate refresh when it comes back, which is exactly the freshness contract
// docs/score/announcer.md asks for. Pass { intervalMs } to poll.
export function useRideStatuses(rideIds, opts) {
  const scoreApi = useScoreApi();
  const fetchStatuses = useCallback(
    async (ids) => unwrap(await scoreApi.rides.batchRideStatus({ rideIds: ids })),
    [scoreApi],
  );
  return useRideStatusesBase(rideIds, fetchStatuses, opts);
}

export default useRideStatuses;
